// src/hooks/useAdminRole.js
// Checks whether the current authenticated user has an administrator role
// by querying user_role_assignments + user_roles (your existing tables).

import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export function useAdminRole() {
  const [isAdmin, setIsAdmin]   = useState(false);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    async function check() {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) { setIsAdmin(false); setLoading(false); return; }

        const { data, error } = await supabase
          .from('user_role_assignments')
          .select('user_roles(role_type)')
          .eq('user_id', user.id)
          .eq('is_active', true);

        if (!error && data) {
          const adminRoles = ['admin', 'superadmin', 'administrator'];
          const found = data.some((row) =>
            adminRoles.includes(row.user_roles?.role_type?.toLowerCase())
          );
          setIsAdmin(found);
        }
      } catch {
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    }
    check();
  }, []);

  return { isAdmin, loading };
}